//export const APP_URL = 'http://zz.peedwork.com';

// export const APP_URL = 'http://yyzz.peedwork.com/zz/';
export const APP_URL = 'http://wx.kq120.com/zz/';
export const img_url = 'http://yayizz.oss-cn-chengdu.aliyuncs.com/';
